const PRODUCT_PAGE_POPUP_TRANSLATIONS_KEY = 'candy_rack_custom_wording-popup';
const THANK_YOU_PAGE_TRANSLATIONS_KEY =
  'candy_rack_custom_wording-thank_you_page';
const CHECKOUT_BUTTON_TRANSLATIONS_KEY = 'candy_rack_custom_wording-checkout';

const STOREFRONT_API_VERSION = '2025-01';

export {
  PRODUCT_PAGE_POPUP_TRANSLATIONS_KEY,
  THANK_YOU_PAGE_TRANSLATIONS_KEY,
  CHECKOUT_BUTTON_TRANSLATIONS_KEY,
  STOREFRONT_API_VERSION,
};
